import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalOptions {
  title?: string;
  content: ReactNode;
  footer?: ReactNode;
  onClose?: () => void;
}

interface ModalContextType {
  openModal: (options: ModalOptions) => void;
  closeModal: () => void;
  isOpen: boolean;
  modalOptions: ModalOptions | null;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalOptions, setModalOptions] = useState<ModalOptions | null>(null);

  const openModal = (options: ModalOptions) => {
    setModalOptions(options);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    if (modalOptions?.onClose) modalOptions.onClose();
    setModalOptions(null);
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal, isOpen, modalOptions }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) throw new Error('useModal must be used within ModalProvider');
  return context;
};